<div class="flex min-h-full w-full">
  <app-sidebar-menu class="h-screen"/>
  <div class="flex-grow-1 p-4 h-screen overflow-y-scroll">
    <router-outlet/>
  </div>
</div>
